import React from "react";
import * as styles from "/src/components/Resource/ResourceCategories.module.css";
import { graphql, useStaticQuery, Link } from "gatsby";
import { v4 as uuidv4 } from "uuid";
import slugify from "slugify";

const BlogCategories = () => {
  const data = useStaticQuery(query);
  const allBlogs = data.allContentfulBlogPost.nodes;
  let groupedBlog = {};
  for (const value of allBlogs) {
    if (groupedBlog.hasOwnProperty(value["category"])) {
      groupedBlog[value["category"]].push(value);
    } else {
      groupedBlog[value["category"]] = [value];
    }
  }
  let categories = Object.keys(groupedBlog);
  const Categories = () => {
    return (
      <>
        {categories.map((category) => (
          <div
            key={uuidv4()}
            style={{
              boxSizing: "border-box",
              marginBottom: 20,
              marginRight: 20,
            }}
            className={`col-3 p-15`}
          >
            <div className={styles.categoryTitle}>{category}</div>
            <ul>
              {groupedBlog[category].map((entry) => (
                <li key={uuidv4()} className={styles.categoryList}>
                  <Link
                    to={`/blog/${slugify(entry["title"], {
                      lower: true,
                      strict: true,
                    })}`}
                    className={styles.categoryItem}
                  >
                    {entry["title"]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </>
    );
  };
  return (
    <>
      <div
        className="section-header left-header pv-10"
        style={{ justifyContent: "center" }}
      >
        Articles by Topic
      </div>
      <div
        style={{ justifyContent: "space-around" }}
        className={styles.categoryWrapper}
      >
        <Categories />
      </div>
    </>
  );
};

export const query = graphql`
  {
    allContentfulBlogPost {
      nodes {
        category
        createdAt
        summary
        title
        createdBy
      }
    }
  }
`;

export default BlogCategories;
